module.exports = __webpack_public_path__ + "img/cross.331ccedf.svg";